<i18n>
{
  "fr": {
  },
  "en": {
  }
}
</i18n>

<template>
  <div>
    <b-collapse
      v-for="(category, indexs) in getCategories()"
      :key="indexs"
      :open="true"
    >
      <template #trigger="props">
        <b-notification :closable="false">
          <b-icon :icon="!props.open ? 'caret-down' : 'caret-up'"></b-icon>
          <strong> {{ $t(category) }} </strong>
        </b-notification>
      </template>
      <b-tabs :animated="false">
        <b-tab-item
          v-for="(type, indexs) in getTypes(category)"
          :key="indexs"
          :label="$t(type)"
        >
          <component :is="importName(type)" />
        </b-tab-item>
      </b-tabs>
    </b-collapse>
  </div>
</template>

<script>
import Vue from 'vue'
import { ResearchActivity } from '@/models/carbon/ResearchActivity.js'

export default {
  name: 'HelpCalculatingMethod',
  methods: {
    getCategories: function () {
      return ResearchActivity.getCategories()
    },
    getTypes: function (category) {
      return ResearchActivity.getTypes(category)
    },
    getComponentName: function (type) {
      let componentName = null
      if (type) {
        let parts = type.split('.')
        componentName = parts
          .map((val) => {
            return val.charAt(0).toUpperCase() + val.slice(1)
          })
          .join('')
      }
      return componentName
    },
    getDirectoryName: function (type) {
      return type.split('.').join('')
    },
    importName: function (type) {
      return this.getComponentName(type) + 'Doc'
    }
  },
  beforeMount () {
    for (let category of this.getCategories()) {
      for (let type of this.getTypes(category)) {
        Vue.component(this.importName(type), () =>
          import(
            '@/components/carbon/forms/ractivities/components/' +
              this.getDirectoryName(type) +
              '/HelpCalculatingMethod.vue'
          )
        )
      }
    }
  }
}
</script>
